import type { MailboxDisplay } from './types';

interface MailboxRowInput {
    mailId: number;
    fromPlayerId: string;
    fromDisplayName: string;
    toPlayerId: string;
    toDisplayName: string;
    msg: string;
    trade: string;
    read: boolean;
    timeSent: unknown;
}

export function mapMailboxRows(rows: MailboxRowInput[]): MailboxDisplay[] {
    return rows.map((row) => ({
        mailId: row.mailId,
        fromPlayerId: row.fromPlayerId,
        fromDisplayName: row.fromDisplayName || row.fromPlayerId.substring(0, 8),
        toPlayerId: row.toPlayerId,
        toDisplayName: row.toDisplayName || row.toPlayerId.substring(0, 8),
        msg: row.msg,
        trade: row.trade,
        read: row.read,
        timeSent: row.timeSent,
    }));
}
